import { format, parse } from 'url';

const appendParam = (link: string, key: string, value: string, fullLink: boolean = true) => {
  if (!link) {
    return '';
  }
  const url = parse(link, true);
  if (value) {
    url.query[key] = value;
  }
  url.search = null;
  const formattedUrl = format(url);
  if (!fullLink) {
    const reparsedUrl = parse(formattedUrl);
    return `${reparsedUrl.pathname}${reparsedUrl.search}`;
  }
  return formattedUrl;
};

export default appendParam;
